/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const preheatCollectionCropsV1DataSchema = z.object({
  enqueuedCount: z.number(),
  duplicateCount: z.number(),
  skippedCount: z.number(),
});

export const preheatCollectionCropsV1ResponseSchema = createApiResponseSchema(
  preheatCollectionCropsV1DataSchema,
) as z.ZodSchema<IAPI<IPreheatCollectionCropsV1Data>>;

export interface IPreheatCollectionCropsV1Data {
  enqueuedCount: number;
  duplicateCount: number;
  skippedCount: number;
}

export type IPreheatCollectionCropsV1Response = IAPI<IPreheatCollectionCropsV1Data>;
